import type { PropsWithChildren } from "react";

interface IconContainerProps {
  dataTestId?: string;
}

export const IconContainer = ({
  children,
  dataTestId,
}: PropsWithChildren<IconContainerProps>) => (
  <div className="flex flex-row gap-x-1" data-testid={dataTestId}>
    {children}
  </div>
);
